import type { z } from 'zod';
import type { RsvpInput } from '../../../lib/types';

export const FIELD_LABEL: Partial<Record<keyof RsvpInput, string>> = {
  parent_email: 'Guardian email',
  parent_name: 'Guardian name',
  parent_phone: 'Guardian phone',
  child_name: "Child's name",
  shirt_size: 'Shirt size',
  character_id: 'Fighter',
  rsvp_status: 'RSVP status',
};

type ZodIssueLike = Pick<z.ZodIssue, 'path' | 'message' | 'code'>;

const labelFor = (key: unknown): string => {
  if (typeof key !== 'string') return 'field';
  return FIELD_LABEL[key as keyof RsvpInput] ?? key;
};

export function formatSubmitError(error: string, issues: unknown): string {
  if (error === 'character_taken') {
    return 'Someone just claimed that fighter — pick another.';
  }
  if (error === 'invalid' && Array.isArray(issues) && issues.length) {
    const parts = (issues as ZodIssueLike[]).map((i) => {
      const field = labelFor(i.path?.[0]);
      return `${field}: ${i.message ?? 'invalid'}`;
    });
    return parts.join('; ');
  }
  return `Submit failed: ${error}`;
}
